import React from "react";
import { Link } from "react-router-dom";

export default function GrupoWpp() {
  React.useEffect(() => {
    // Google Tag Manager
    const gtmScript = document.createElement("script");
    gtmScript.async = true;
    gtmScript.src = "https://www.googletagmanager.com/gtm.js?id=GTM-PR5KTQF8";
    document.head.appendChild(gtmScript);

    const gtmDataLayer = document.createElement("script");
    gtmDataLayer.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag("js", new Date());
      gtag("config", "GTM-PR5KTQF8");
    `;
    document.head.appendChild(gtmDataLayer);

    // GTM noscript fallback
    const noscript = document.createElement("noscript");
    noscript.innerHTML = "<iframe src=\"https://www.googletagmanager.com/ns.html?id=GTM-PR5KTQF8\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>";
    document.body.insertBefore(noscript, document.body.firstChild);

    return () => {
      // Cleanup scripts
      const scripts = document.querySelectorAll("script[src*=\"googletagmanager.com\"]");
      scripts.forEach((script) => script.remove());
    };
  }, []);

  return (
    <div className="min-h-screen bg-black text-white">
      {/* Header */}
      <header className="border-b border-white/10 backdrop-blur-sm bg-black/30">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img
              src="https://static.lumi.new/65/65f85551bb8e2acf68da5047ed864ca5.webp"
              alt="EW Pass"
              className="h-10 md:h-12"
            />
          </Link>
          <img
            src="https://static.lumi.new/77/777c8760a332e404d06032ec68435a95.webp"
            alt="Header Image"
            className="h-10 md:h-12 object-contain"
          />
        </div>
      </header>

      {/* Hero Section */}
      <section className="container mx-auto px-4 py-16 md:py-24">
        <div className="max-w-4xl mx-auto text-center">
          {/* Headline with fire emojis */}
          <div className="flex items-center justify-center gap-4 mb-6">
            <span className="text-5xl md:text-7xl">🔥</span>
            <h1 className="text-4xl md:text-6xl font-bold leading-tight whitespace-nowrap">
              BLACK FRIDAY EW PASS
            </h1>
            <span className="text-5xl md:text-7xl">🔥</span>
          </div>
          
          <p className="text-2xl md:text-4xl font-semibold text-yellow-400 mb-8">
            Faça parte desse seleto grupo e receba ofertas especiais feitas para você!
          </p>

          {/* WhatsApp Button */}
          <a
            href="https://chat.whatsapp.com/Ks6KNX0aA1v9X24ierqMNT"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-green-600 hover:bg-green-700 rounded-full px-8 py-4 text-lg md:text-xl font-bold text-white transition-all hover:scale-105 shadow-2xl"
          >
            CLIQUE AQUI PARA SER VIP AGORA
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-white/10 py-8 mt-16">
        <div className="container mx-auto px-4 text-center text-gray-400 text-sm">
          <p>© 2024 EW Pass. Todos os direitos reservados.</p>
        </div>
      </footer>
    </div>
  );
}
